/* eslint-disable import/no-cycle */
import {
  BooleanField,
  ColorField,
  FieldWrapper,
  HierarchyTreeField,
  HierarchyTreeWorkplaceField,
  InputField,
  ModelPropertySelectField,
  NumberField,
  PropertiesField,
  SelectField,
  PropertiesSelectDisplayField,
  CustomTabEditorField,
} from './WidgetSettingsFormFields';
import Form from '../form/Form';

const WidgetSettingFormField = ({field, form}) => {
  switch (field.type) {
    case WidgetSettingFormField.fieldTypes.String:
      return (
        <FieldWrapper field={field}>
          <InputField field={field} autoComplete={'off'}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.Select:
      return (
        <FieldWrapper field={field}>
          <SelectField field={field}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.SelectMultiple:
      return (
        <FieldWrapper field={field}>
          <SelectField mode="multiple" field={field}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.SelectTags:
      return (
        <FieldWrapper field={field}>
          <SelectField mode="tags" field={field}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.Number:
      return (
        <FieldWrapper field={field}>
          <NumberField field={field} autoComplete={'off'}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.Boolean:
      return (
        <FieldWrapper field={field} valuePropName={'checked'}>
          <BooleanField field={field}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.Properties:
      return (
        <div style={{marginBottom: '24px'}}>
          <Form.Item name={field.id} noStyle>
            <PropertiesField label={field.label} availableProperties={field.properties} texts={field.texts}/>
          </Form.Item>
        </div>
      );
    case WidgetSettingFormField.fieldTypes.Color:
      return (
        <FieldWrapper field={field}>
          <ColorField field={field}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.HierarchyTree:
      return (
        <FieldWrapper field={field}>
          <HierarchyTreeField field={field}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.HierarchyTreeMultiple:
      return (
        <FieldWrapper field={field}>
          <HierarchyTreeField field={field} treeCheckable/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.ModelPropertySelectField:
      return <ModelPropertySelectField field={field} form={form}/>;
    case WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField:
      return <PropertiesSelectDisplayField field={field} form={form}/>;
    case WidgetSettingFormField.fieldTypes.HierarchyTreeWorkplace:
      return (
        <FieldWrapper field={field}>
          <HierarchyTreeWorkplaceField field={field}/>
        </FieldWrapper>
      );
    case WidgetSettingFormField.fieldTypes.CustomTabEditor:
      return <CustomTabEditorField field={field} form={form}/>;
    default:
      return null;
  }
};

WidgetSettingFormField.fieldTypes = {
  String: 'String',
  Boolean: 'Boolean',
  Number: 'Number',
  Select: 'Select',
  SelectMultiple: 'SelectMultiple',
  SelectTags: 'SelectTags',
  Properties: 'Properties',
  Color: 'Color',
  HierarchyTree: 'HierarchyTree',
  HierarchyTreeMultiple: 'HierarchyTreeMultiple',
  ModelPropertySelectField: 'ModelPropertySelectField',
  HierarchyTreeWorkplace: 'HierarchyTreeWorkplace',
  CustomTabEditor: 'CustomTabEditor',
  PropertiesSelectDisplayField: 'PropertiesSelectDisplayField',
};

export default WidgetSettingFormField;
